const profileEnum = {
  MANAGER: 1,
  COLABORATOR: 2,
}

export default profileEnum
